<script setup lang="ts">
import { usePejer } from '@/Pejer'
import { Landmark } from 'lucide-vue-next'
import { Button } from 'pejer/src/components/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from 'pejer/src/components/ui/dialog'
import DialogFooter from 'pejer/src/components/ui/dialog/DialogFooter.vue'
import usePejerQuery from 'pejer/src/usePejerQuery'
import { ref } from 'vue'
import ClubAccountHistoryList from './ClubAccountHistoryList.vue'
import { ClubAccountItem } from './types'

const props = defineProps<{
  item: ClubAccountItem
}>()

const isOpen = ref(false)
const pejer = usePejer()

const { data: history, isLoading } = usePejerQuery(pejer.urls.payments['club-account-history'], {
  pathArgs: { id: props.item.paymentReferenceID },
  queryKey: ['club-account-history', props.item.paymentReferenceID],
  enabled: isOpen,
})
</script>
<template>
  <Dialog v-model:open="isOpen">
    <DialogTrigger as-child>
      <slot />
    </DialogTrigger>
    <DialogContent class="max-w-[calc(100vw-20px)] max-h-[calc(100vh-50px)] flex flex-col">
      <DialogTitle class="flex flex-col gap-1">
        <span class="text-muted-foreground text-sm">{{ item.customerName }}</span>
        <span class="text-lg font-semibold">{{ item.description }}</span>
      </DialogTitle>
      <DialogDescription class="flex items-center gap-2 text-sm text-slate-600">
        <Landmark :size="16" class="shrink-0" />
        Innbetalinger og tilbakebetalinger på klubbens egen konto.
        <span v-if="item.kid">KID {{ item.kid }}</span>
      </DialogDescription>
      <div class="py-2 text-sm overflow-y-auto">
        <ClubAccountHistoryList :history="history" :is-loading="isLoading" />
      </div>
      <DialogFooter>
        <DialogClose as-child>
          <Button variant="ghost">Lukk</Button>
        </DialogClose>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>
